/** @format */

import React, { useEffect, useState } from "react";
import DamChart from "./damchart";
import DamTable from "./damtable";
import SummaryCallOption from "./SummaryCallOption";
import "../Style/homepage.css";
import { fetchAllClients, loginClient } from "../api-helper/damapi";

function HomePage({ submittedEmail, setSubmittedEmail }) {
  const [email, setEmail] = useState("");
  const [allClientEmails, setAllClientEmails] = useState([]);
  const [error, setError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const lowerEmail = email.trim().toLowerCase();

    try {
      const res = await loginClient(lowerEmail, password); // 👈 login με password
      if (res.success) {
        localStorage.setItem("loggedInEmail", lowerEmail);
        setSubmittedEmail(lowerEmail);
        setError("");
      } else {
        setError("Invalid email or password.");
      }
    } catch (err) {
      setError("Something went wrong.");
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("loggedInEmail");
    if (savedEmail) {
      setSubmittedEmail(savedEmail);
    }
  }, []);

  return (
    <div className='home-container'>
      {!submittedEmail ? (
        <form onSubmit={handleSubmit} className='email-form'>
          <h2>Sign in with your email</h2>

          <div className='input-block'>
            <label>Email</label>
            <input
              type='email'
              placeholder='you@example.com'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className='input-block'>
            <label>Password</label>
            <input
              type='password'
              placeholder='••••••••'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type='submit'>Continue</button>

          {error && <p className='error-message'>{error}</p>}
        </form>
      ) : (
        <>
          <div className='dashboard-row'>
            <DamChart
              email={submittedEmail}
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
            />
            <SummaryCallOption
              email={submittedEmail}
              selectedMonth={selectedMonth}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default HomePage;
